function fetchStatsQuery (id) {
  let variables = {
    id: id || 1
  }
  return {
    operationName: 'fetchStats',
    variables,
    query: `
      query fetchStats($id: ID!) {
        organisationalUnit(id: $id) {
          forschungsprojekt: projects {
            meta { totalEntries }
          }
          publikation: publications {
            meta { totalEntries }
          }
          preis: awards {
            meta { totalEntries }
          }
          kooperation: cooperations {
            meta { totalEntries }
          }
          veranstaltung: events {
            meta { totalEntries }
          }
        }
      }
    `
  }
}

export { fetchStatsQuery }



// WEBPACK FOOTER //
// ./src/graphql/stats.js